<script setup lang="ts">
  import { ref, watch } from 'vue'
  import { debounce } from '@/functions'

  const props = defineProps<{
    placeholder?: string,
    loading?: boolean,
    modelValue: string,
    label?: string,
  }>()

  const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void,
  }>()
  const search = ref(props.modelValue)
  const submit = debounce(() => {
    emit('update:modelValue', search.value)
  }, 500)
  watch(() => props.modelValue, (newValue) => {
    search.value = newValue
  })
  watch(search, submit)
</script>

<template>
  <app-input
    v-model="search"
    :label="label"
    type="search"
    :placeholder="placeholder ?? 'Cari...'"
    @keyup.enter="submit.trigger()">
    <template #inline>
      <div class="absolute flex-center text-sm text-gray-300 w-9">
        <fa-icon icon="i-far-magnifying-glass" />
      </div>
      <div class="absolute right-1 flex items-center text-xs z-10 text-gray-600 inset-y-0">
        <div
          v-if="loading"
          class="flex-center h-6 w-6">
          <fa-icon
            icon="i-fas-circle-notch"
            class="animate-spin" />
        </div>
        <app-button
          v-else-if="search"
          class="h-6 w-6 flex-center rounded-full hover:bg-gray-200"
          @click="search = ''">
          <fa-icon icon="i-fas-xmark" />
        </app-button>
      </div>
    </template>
  </app-input>
</template>

<style scoped>
  @reference "@/assets/styles/main.css";

  :deep(input) {
    @apply pl-9 pr-8 placeholder-shown:pr-4;
  }
</style>
